import { __awaiter } from "tslib";
import Vue from 'vue';
import moment from 'moment';
export default Vue.extend({
    name: 'spotAhead',
    props: {
        isSelectedElBlocked: {
            type: Boolean,
            required: true,
            default: false
        },
        selectedItems: {
            type: Array,
            required: true
        },
        selectedFolders: {
            type: Array,
            required: true
        },
        availableToMoveFolders: {
            type: Array,
            required: true
        },
        itemsLength: {
            type: Number,
            required: true
        },
        availableToConvertLength: {
            type: Number,
            required: true
        },
        availableToSellLength: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        searchPhrase: '',
        burnBNBState: false,
        codeError: false,
        burnBNBAwait: false,
        moveMenuIsOpened: false,
        context: {
            x: 0,
            y: 0
        }
    }),
    computed: {
        haveSelectedItems() {
            const vm = this;
            return vm.selectedItems.length > 0;
        },
        haveSelectedFolders() {
            const vm = this;
            return vm.selectedFolders.length > 0;
        },
        letBlockItems() {
            const vm = this;
            const isOneElementWithPositiveVal = vm.selectedItems.length === 1 && !vm.selectedItems[0].isAvailableToPay;
            return Boolean(vm.selectedItems.find((item) => !item.isDefaultLocked)) && isOneElementWithPositiveVal;
        },
        letBlockFolders() {
            const vm = this;
            let result = true;
            for (const folder of vm.selectedFolders) {
                if (folder.items.every((item) => item.isDefaultLocked))
                    result = false;
            }
            return result;
        }
    },
    watch: {
        searchPhrase(value, oldValue) {
            const vm = this;
            if (value.length === 0 && oldValue.length !== 0) {
                vm.$emit('onChangeSearchField', '');
            }
        },
        availableToMoveFolders() {
            const vm = this;
            vm.moveMenuIsOpened = false;
        },
        moveMenuIsOpened(v) {
            if (v) {
                const vm = this;
                const { moveFolderActivator } = vm.$refs;
                const boundingRect = moveFolderActivator.$el.getBoundingClientRect();
                vm.context.x = boundingRect.left;
                vm.context.y = boundingRect.top + 24;
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        tryGoHistory() {
            const vm = this;
            vm.$router.push({ name: 'spotHistory' }).then((response) => {
                console.log(response);
            }).catch((error) => {
                console.log(error);
            });
        },
        handleChangeBurnBNB(v) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.burnBNBAwait = true;
                const response = yield vm.services.mainService.setBurnBNBStatusSpot({
                    burnBnb: v
                });
                if (response.success) {
                    vm.burnBNBState = v;
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: v ? vm.$t('spotPage.alerts.content.burnBnbEnabled') : vm.$t('spotPage.alerts.content.burnBnbDisabled')
                    });
                }
                else {
                    vm.burnBNBState = !v;
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('spotPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: v ? vm.$t('spotPage.alerts.content.failedToEnableBnbBurn') : vm.$t('spotPage.alerts.content.failedToDisableBnbBurn')
                    });
                }
                vm.burnBNBAwait = false;
            });
        },
        init(retry = false) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.burnBNBAwait = true;
                const response = yield vm.services.mainService.getBurnBNBStatusSpot(null);
                if (response.success) {
                    vm.burnBNBState = response.data.burnBnb;
                    vm.burnBNBAwait = false;
                    vm.$emit('onChangeConvertRules', {
                        available: response.data.canDustAfter === null,
                        convertAfter: response.data.canDustAfter ? response.data.canDustAfter : moment().toJSON()
                    });
                    return true;
                }
                if (retry) {
                    return false;
                }
                return this.init(true);
            });
        }
    }
});
